"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const popover_1 = require("components/cosmos/v2/popover");
const Html_1 = __importDefault(require("components/Html"));
const translate_1 = require("components/translate");
const xIconCloseButton_1 = require("components/xIconCloseButton");
const tracksPopover_module_scss_1 = __importDefault(require("./tracksPopover.module.scss"));
const STORAGE_KEY = 'tracksPopoverClosed';
const TracksPopover = ({ t, onClick }) => {
    const [shouldRenderAlert, setShouldRenderAlert] = (0, react_1.useState)(() => {
        const storageData = localStorage.getItem(STORAGE_KEY);
        return storageData !== 'true';
    });
    const handleClosePopover = () => {
        setShouldRenderAlert(false);
        localStorage.setItem(STORAGE_KEY, String(true));
    };
    const handleRedirectToTracks = () => {
        handleClosePopover();
        onClick();
    };
    if (!shouldRenderAlert) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(popover_1.Popover, { className: tracksPopover_module_scss_1.default.tracksPopover, position: "top", autoShow: true, children: [(0, jsx_runtime_1.jsxs)(popover_1.Popover.Header, { className: "_pb-1 _d-flex _justify-content-between", children: [(0, jsx_runtime_1.jsx)("h5", { className: "_text-2 _text-gray-500 _mb-0", children: t('general.tracks') }), (0, jsx_runtime_1.jsx)(xIconCloseButton_1.XIconCloseButton, { onClick: handleClosePopover, iconClassName: "_text-2 _text-gray-400" })] }), (0, jsx_runtime_1.jsxs)(popover_1.Popover.Body, { className: "_pt-1 _d-flex _flex-column _align-items-end", children: [(0, jsx_runtime_1.jsx)("p", { className: "_mt-2", children: (0, jsx_runtime_1.jsx)(Html_1.default, { children: t('tracks.popover.description') }) }), (0, jsx_runtime_1.jsx)(button_1.default, { onClick: handleRedirectToTracks, size: "sm", variation: "info", children: t('tracks.popover.action') })] })] }));
};
exports.default = (0, translate_1.translate)()(TracksPopover);
